import { RECEIVE_RELATED_PRODUCTS } from 'constants/reduxActions';

import { fetchErrorMiddleware } from 'middleware/fetchErrorMiddleware';
import { relatedProducts } from 'apis/cloudcatalog';

const receiveRelatedProducts = data => ({ type: RECEIVE_RELATED_PRODUCTS, data });

export function fetchRelatedProducts(productId) {
  return function(dispatch, getState) {
    const state = getState();
    const params = { productId };
    const { environmentConfig: { api: { cloudcatalog: cloudCatalogInfo } } } = state;
    relatedProducts(cloudCatalogInfo, params)
      .then(fetchErrorMiddleware)
      .then(res => dispatch(receiveRelatedProducts(res)));
  };
}
